import { css } from "@emotion/react";
import { IconButton } from "@mui/material";
import { MdOutlineContentCopy } from "react-icons/md";

import { Props } from "~/components/quest/page/[id]/lib";
import useCurrentUserVerifyCode from "~/extensions/instant-verify-checker/lib";
import { copyToClipboard } from "~/lib/client/browser_ops";

type Quest = Props["quest"];

const VerifyCode = ({ quest }: { quest: Quest }) => {
  const code = useCurrentUserVerifyCode(quest.id);

  if (!code) {
    return null;
  }

  return (
    <section
      css={css`
        background: #f0f0f0;
        padding: 1rem;
        border-radius: 0.5rem;
        margin-top: 1rem;
        p {
          margin: 0;
        }
      `}
    >
      <p>
        投票コード：{" "}
        <span
          css={css`
            font-weight: bold;
          `}
        >
          {code}
        </span>
        <span>
          <IconButton onClick={() => copyToClipboard(code)}>
            <MdOutlineContentCopy />
          </IconButton>
        </span>
      </p>
      <p
        css={css`
          font-size: 0.75rem;
          color: #666;
        `}
      >
        ※ 投票コードは画面更新などで変わりますが、問題なくご利用いただけます。
      </p>
    </section>
  );
};

export default VerifyCode;
